// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3szE5","image":"Header_image__3ZX62","name":"Header_name__2UHnR","info":"Header_info__i1n-u","infoRow":"Header_infoRow__3mnHi"};